import { render, staticRenderFns } from "./PageNotificationsView.vue?vue&type=template&id=20c3323a&scoped=true&"
import script from "./PageNotificationsView.vue?vue&type=script&lang=ts&"
export * from "./PageNotificationsView.vue?vue&type=script&lang=ts&"
import style0 from "./PageNotificationsView.vue?vue&type=style&index=0&id=20c3323a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c3323a",
  null
  
)

export default component.exports